var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "appointment-body" },
    [
      _vm._m(0),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("應徵姓名")]),
        _c("div", [_vm._v(_vm._s(_vm.appointment.Name))]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("身份別")]),
        _c("div", [_vm._v(_vm._s(_vm.appointment.IdentityType))]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("錄用類型")]),
        _c("div", [_vm._v(_vm._s(_vm.appointment.EmployCategory))]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("薪制")]),
        _c("div", [_vm._v(_vm._s(_vm.appointment.SalaryType))]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("任用部門")]),
        _c("div", [
          _vm._v(
            " " +
              _vm._s(
                _vm.appointment.AppointmentDepartment
                  ? _vm.appointment.AppointmentDepartment.Name
                  : null
              ) +
              " " +
              _vm._s(
                _vm.appointment.AppointmentPlant
                  ? _vm.appointment.AppointmentPlant.Name
                  : null
              ) +
              " "
          ),
        ]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("最高學歷")]),
        _c("div", [_vm._v(_vm._s(_vm.appointment.HighestEducation))]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("學校")]),
        _c("div", [_vm._v(_vm._s(_vm.appointment.School))]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("科系")]),
        _c("div", [_vm._v(_vm._s(_vm.appointment.Department))]),
      ]),
      !(
        _vm.appointment.ResumeType === "IDL" &&
        _vm.appointment.SalaryType === "月薪"
      )
        ? _c("div", { staticClass: "field" }, [
            _c("span", [_vm._v("Offer 顯示單位")]),
            _c("div", [_vm._v(_vm._s(_vm.appointment.OfferDisplayDepartment))]),
          ])
        : _vm._e(),
      !(
        _vm.appointment.ResumeType === "IDL" &&
        _vm.appointment.SalaryType === "月薪"
      )
        ? _c("div", { staticClass: "field" }, [
            _c("span", [_vm._v("報到日期")]),
            _c("div", [
              _vm._v(
                _vm._s(_vm.$common.dateFormatter(_vm.appointment.OnBoardTime))
              ),
            ]),
          ])
        : _vm._e(),
      _vm._m(1),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("職缺名稱")]),
        _c("div", [_vm._v(_vm._s(_vm.appointment.PositionName))]),
      ]),
      !(
        _vm.appointment.ResumeType === "IDL" &&
        _vm.appointment.SalaryType === "月薪"
      )
        ? _c("div", { staticClass: "field" }, [
            _c("span", [_vm._v("任用職稱")]),
            _c("div", [_vm._v(_vm._s(_vm.appointment.AppointmentPosition))]),
          ])
        : _vm._e(),
      !(
        _vm.appointment.ResumeType === "IDL" &&
        _vm.appointment.SalaryType === "月薪"
      )
        ? _c("div", { staticClass: "field" }, [
            _c("span", [_vm._v("職等")]),
            _c("div", [_vm._v(_vm._s(_vm.appointment.Rank))]),
          ])
        : _vm._e(),
      _vm.appointment.ResumeType === "DL" &&
      _vm.appointment.SalaryType === "月薪"
        ? _c("div", { staticClass: "field" }, [
            _c("span", [_vm._v("月薪")]),
            _c("div", [_vm._v(_vm._s(_vm.appointment.BasicSalary))]),
          ])
        : _vm._e(),
      _vm.appointment.SalaryType === "時薪"
        ? _c("div", { staticClass: "field" }, [
            _c("span", [_vm._v("時薪")]),
            _c("div", [_vm._v(_vm._s(_vm.appointment.HourSalary))]),
          ])
        : _vm._e(),
      !(
        _vm.appointment.ResumeType === "IDL" &&
        _vm.appointment.SalaryType === "月薪"
      )
        ? [
            _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v("聘僱期間")]),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$common.dateFormatter(_vm.appointment.EmploymentStart)
                    ) +
                    "~" +
                    _vm._s(
                      _vm.$common.dateFormatter(_vm.appointment.EmploymentEnd)
                    ) +
                    " "
                ),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v("工作時間")]),
              _c("div", [_vm._v(_vm._s(_vm.appointment.WorkTimeType))]),
            ]),
            _vm.appointment.WorkTimeType === "一般工時"
              ? _c("div", { staticClass: "field" }, [
                  _c("span", [_vm._v("班別")]),
                  _c("div", [_vm._v(_vm._s(_vm.appointment.WorkShiftType))]),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.appointment.WorkShiftTypeGuid ===
      "11111111-1111-1111-1111-111111111111"
        ? [
            _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v("班別描述")]),
              _c("div", [_vm._v(_vm._s(_vm.appointment.WorkShiftTypeDesc))]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v("休息分鐘數")]),
              _c("div", [_vm._v(_vm._s(_vm.appointment.BreakMinute))]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v("每日工時")]),
              _c("div", [_vm._v(_vm._s(_vm.appointment.DailyWorkHour))]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v("每週工時")]),
              _c("div", [_vm._v(_vm._s(_vm.appointment.WeeklyWorkHour))]),
            ]),
          ]
        : _vm._e(),
      _vm.appointment.WorkTimeType === "特殊工時"
        ? _c("div", { staticClass: "field" }, [
            _c("span", [_vm._v("出勤類型")]),
            _c("div", [_vm._v(_vm._s(_vm.appointment.SpecialWorkTimeType))]),
          ])
        : _vm._e(),
      _vm.appointment.SpecialWorkTimeType === "約定工時"
        ? [
            _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v("約定週工時")]),
              _c("div", [_vm._v(_vm._s(_vm.appointment.SpecialWeeklyHour))]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v("約定月工時")]),
              _c("div", [_vm._v(_vm._s(_vm.appointment.SpecialMonthlyHour))]),
            ]),
          ]
        : _vm._e(),
      _c("div", { staticClass: "field" }, [
        _c("span", [_vm._v("其他說明")]),
        _c("div", [_vm._v(_vm._s(_vm.appointment.Description))]),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tab-name" }, [
      _c("div", { staticClass: "name-inner" }, [
        _c("span", [_vm._v("1")]),
        _vm._v(" 任用資訊 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tab-name" }, [
      _c("div", { staticClass: "name-inner" }, [
        _c("span", [_vm._v("2")]),
        _vm._v(" 任用建議 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }